import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";
const programConfigs = degreesConfig.programs.rice;

export const rice = {
  slug: "rice",
  name: "Rice University",
  colors: {
    primary1: "#d23228",
    primary2: "#fecf48",
    primary3: "#00262b",
    primary4: "#1576d4",
  },
  programConfigs,
};
